import React__default from 'react';
import { Heading, Text } from '@grandvisionhq/elements';

const Details = ({ brand , name  })=>/*#__PURE__*/ React__default.createElement("header", {
        className: "product-block-details"
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        className: "product-block-details__brand",
        variant: "subheading1"
    }, brand), /*#__PURE__*/ React__default.createElement(Text, {
        className: "product-block-details__name",
        variant: "caption"
    }, name))
;
var Details$1 = Details;

export { Details, Details$1 as default };
//# sourceMappingURL=Details.js.map
